export default "__VITE_ASSET__BCUgyIEY__"